// extracted by mini-css-extract-plugin
export default {"messageFormHeading":"MessageForm_messageFormHeading__WCXPM","messageFormClickableText":"MessageForm_messageFormClickableText__onbIM","formGroup":"MessageForm_formGroup__lYne5"};